<template>
  <div class="welcome-page">
    <hit-panel
      :title="$t('hit-admin.common.welcome-title')"
      :resizable="false"
      size="maximized"
    >
      <template #body>
        <p class="text-base text-gray-800">
          {{ $t('hit-admin.common.welcome-text') }}
        </p>
      </template>
    </hit-panel>
  </div>
</template>

<script>
import {defineComponent} from 'vue';
import {HitPanel} from '@hit/components';

export default defineComponent({
  name: 'WelcomePage',
  components: {
    HitPanel,
  },
});
</script>

<style lang="scss" scoped>
.welcome-page {
  #container-body {
    padding-left: 0.5rem;
  }
}
</style>
